import React from 'react'
import PropTypes from "prop-types";
import { sendEvent } from '../../helpers/analytics'

import './logo.critical.css'

const Logo = (props) => {
  let { image, mobile, link } = props
  const logoClass = 'logo--centered logo--' + image
  return (
    <div className={logoClass}>
      <a href={link} target="_blank" className="logo" onClick={() => sendEvent('main', 'click', image)}>
        <span >
          <img src={`/images/${image}.png`} alt={image} className="logo__image" />
          {mobile ? <img src={`/images/${image}-mobile.png`} alt={image} className="logo__image --mobile" /> : null}
        </span>
      </a>
    </div>
  )
}

Logo.propTypes = {
  link: PropTypes.string,
  image: PropTypes.string,
  mobile: PropTypes.bool
}

export default Logo


// WEBPACK FOOTER //
// ./src/components/logo/logo.js